import React, { useContext, useState } from "react";
import { useSortable } from "@dnd-kit/sortable";

import ItemUs from "./ItemUs";

const ColumnItem = ({ id, title, items,openChat }) => {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id });
  return (
    <div className="bg-light" ref={setNodeRef} {...attributes}>
      <h5 className="p-1 bg-info text-white border-bottom border-light">{title}</h5>
      {/* <hr /> */}
      {items.length === 0 ? (
        <p className="px-2">Sin chats</p> // Mensaje si la columna está vacía
      ) : (
        <div
          className="overflow-auto"
          style={{ maxHeight: "82vh", margin: "0px", padding: "0px" }}
        >
          {items.map((item, index) => (
            <ItemUs
              key={item.id}
              user={item}
              id={id}
              listeners={listeners}
              transform={transform}
              transition={transition}
              openChat={openChat}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default ColumnItem;
